import {Injectable} from "@angular/core";
import {Translations} from "./translations.model";
import {StandardName} from "../../store/state/order.state";
import {Observable, Subject} from "rxjs";

@Injectable()
export class TranslationsHelperService {

	private _translations: Translations[];
	private translationsUpdated$: Subject<any> = new Subject<any>();

	setTranslations(translations: Translations[]) {
		this._translations = translations;
		this.translationsUpdated$.next({});
	}

	onTranslationsUpdated(): Observable<any> {
		return this.translationsUpdated$.asObservable();
	}

	translationExists(standard: StandardName, translationSubject: string, useOriginalTranslations: boolean): boolean {
		let translations = this.getTranslations(useOriginalTranslations);
		return !!translations && translations.productTranslations[standard].some(translation => translation.subject == translationSubject);
	}

	translationCommentExists(useOriginalTranslations: boolean): boolean {
		let translations = this.getTranslations(useOriginalTranslations);
		return !!translations && !!translations.comment;
	}

	getTranslation(standard: StandardName, subject: string, useOriginalTranslations: boolean) {
		let translations = this.getTranslations(useOriginalTranslations);
		return translations.productTranslations[standard].find(translation => translation.subject == subject).text;
	}

	getComment(useOriginalTranslations: boolean): string {
		let translations = this.getTranslations(useOriginalTranslations);
		return translations.comment;
	}

	getCurrentTranslations(): Translations | null {
		if (!!this._translations) {
			return this._translations.length > 1 ? this._translations.find(t => t.isDraft) : this._translations[0];
		}

		return null;
	}

	allTranslationsProvided(): boolean {
		let translations = this.getCurrentTranslations();
		return !!translations ?
			Object.keys(translations.productTranslations).every(standard =>
				translations.productTranslations[standard].every(translation => translation?.text?.length > 0)
			) :
			false;

	}

	private getTranslations(original: boolean): Translations {
		return original ?
			(!!this._translations ? this._translations.find(t => t.isDraft == false) : null) :
			this.getCurrentTranslations();
	}
}
